const RefreshToken = function (tokenString) {
  this.tokenString = tokenString;
};

module.exports = RefreshToken;
